module.exports = __webpack_public_path__ + "static/img/righteous-regular.4bfee50.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/righteous-regular.svg
// module id = oFyf
// module chunks = 1